import { render, staticRenderFns } from "./EmployeeView.vue?vue&type=template&id=8c6901ac&scoped=true"
import script from "./EmployeeView.vue?vue&type=script&lang=js"
export * from "./EmployeeView.vue?vue&type=script&lang=js"
import style0 from "./EmployeeView.vue?vue&type=style&index=0&id=8c6901ac&prod&lang=scss"
import style1 from "./EmployeeView.vue?vue&type=style&index=1&id=8c6901ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6901ac",
  null
  
)

export default component.exports